import * as React from "react";
import { Button, ButtonProps } from "~/sharedComponents/buttons";
import * as buttonStyles from "~/sharedComponents/buttons/Button.less";

type CallBack = (args: any) => void;

type RenderTargetArgs = {
    sourceTarget: React.ReactElement<any>;
    onClick: CallBack;
    onKeyDown?: CallBack;
    onKeyUp?: CallBack;
    /**
     * Makes trigger active if popup content is rendered.
     * Note: only works for buttons, for other trigger types please use PopoverProps.openedClass prop.
     */
    active?: boolean;
    text?: string;
};

export const renderTarget = ({ sourceTarget, onClick, onKeyDown, onKeyUp, active, text }: RenderTargetArgs) => {
    if (sourceTarget.type && (sourceTarget.type as typeof Button).IsButton) {
        const props: ButtonProps = {
            action: onClick,
            active,
        };

        if (text != null) {
            // update target prop text only when there is a prop text from parent
            // otherwise it doesn't work with default buttons
            props.text = text;
        }

        return React.cloneElement<ButtonProps>(sourceTarget, props);
        // if target is simple html tag (like div, a, span and etc)
    } else if (typeof sourceTarget.type === "string") {
        return React.cloneElement<React.HTMLAttributes<any>>(sourceTarget, {
            onClick,
            onKeyDown,
            onKeyUp,
        });
    }

    // to show button wrappers components as active when popover is opened
    // for example case like
    // <Popover>
    //     <GridFieldsSelectorButton>
    //     ...
    // </Popover>
    const className = active ? buttonStyles.active_parent : null;

    // if target is custom component and we don't know how to attach onClick on it
    // in this case wrap into span and attach click to wrapper
    return (
        <span
            data-testid="render-target-wrapper"
            className={className}
            onClick={onClick}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
        >
            {sourceTarget}
        </span>
    );
};
